import { env, EXTENSION_ID, URL_SERVER_MEDIA } from 'helpers/config'
import { validate } from 'email-validator'

const utils = {
  getFullAuthDeviceData: () => {
    return {
      timeOpened: new Date(),
      timeZoneOffset: new Date().getTimezoneOffset() / 60,
      timeZone: utils.getUserTimeZone(),
      pageon: window.location.pathname,
      referrer: document.referrer,
      previousSites: window.history.length,
      browserName: navigator.appName,
      browserEngine: navigator.product,
      browserVersion1a: navigator.appVersion,
      browserVersion1b: navigator.userAgent,
      browserLanguage: navigator.language,
      browserOnline: navigator.onLine,
      browserPlatform: navigator.platform,
      javaEnabled: navigator.javaEnabled(),
      dataCookiesEnabled: navigator.cookieEnabled,
      sizeScreenW: window.screen.width,
      sizeScreenH: window.screen.height,
      sizeDocW: window.document.body.offsetWidth,
      sizeDocH: window.document.body.offsetHeight,
      sizeInW: window.innerWidth,
      sizeInH: window.innerHeight,
      sizeAvailW: window.screen.availWidth,
      sizeAvailH: window.screen.availHeight,
      scrColorDepth: window.screen.colorDepth,
      scrPixelDepth: window.screen.pixelDepth,
    }
  },

  setChromeExtension: (deviceToken: string) => {
    window.chrome?.runtime?.sendMessage(EXTENSION_ID, {
      type: 'SET_AUTH_DEVICE_TOKEN',
      deviceToken,
      domain: window.location.hostname,
    })
  },

  getUserTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles'
  },

  getDomainCookie: () => {
    let domain = ''
    if (env === 'local') domain = 'localhost'
    if (env === 'dev') domain = '.nachonacho.co'
    if (env === 'production') domain = '.nachonacho.com'
    return domain
  },

  isValidEmail(email: string) {
    return validate(email)
  },

  getUrlFileMedia(urlFile: string) {
    if (!urlFile) return ''
    if (urlFile.substring(0, 4) === 'http') return urlFile
    if (urlFile.substring(0, 7) === '/static') return urlFile
    return `${URL_SERVER_MEDIA}/${urlFile}`
  },

  priceFormatedUSDNoDecimals(priceToFormat: number) {
    if (priceToFormat === null) return '0'
    return (
      '$' +
      priceToFormat
        .toFixed(0)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    )
  },
}

export default utils
